module.exports = __webpack_public_path__ + "static/media/Counter.acaf5c2b.svg";